import { FC } from "react";
import { Flex } from "@chakra-ui/react";

import { CheckIcon } from "@shared/components/Icons";
import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";

const CaseDocumentSavedLabel: FC<{ label?: string }> = ({ label = "Saved" }) => (
  <Flex align="center" gap="5px" fontSize="13px" fontWeight={FONT_WEIGHT.HEAVY} color="score.highText">
    <CheckIcon boxSize="13px" />
    {label}
  </Flex>
);

export default CaseDocumentSavedLabel;
